/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown>, low: NonNullable<unknown>, high: NonNullable<unknown> }} Entrance_ReadingInputs */



/**
* | output |
* | --- |
* | "Newcomers answered: {value} · usually {low}–{high}" |
*
* @param {Entrance_ReadingInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const entrance_reading = /** @type {((inputs: Entrance_ReadingInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrance_ReadingInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Новичкам ответили: ${i?.value} · обычно ${i?.low}–${i?.high}`)
	return /** @type {LocalizedString} */ (`Newcomers answered: ${i?.value} · usually ${i?.low}–${i?.high}`)
});